import React from 'react';
import { withSvg } from './Svg';

const SvgTime = () => (
  <path d="M6.99398 0.333008C3.31398 0.333008 0.333984 3.31967 0.333984 6.99967C0.333984 10.6797 3.31398 13.6663 6.99398 13.6663C10.6807 13.6663 13.6673 10.6797 13.6673 6.99967C13.6673 3.31967 10.6807 0.333008 6.99398 0.333008ZM7.00065 12.333C4.05398 12.333 1.66732 9.94634 1.66732 6.99967C1.66732 4.05301 4.05398 1.66634 7.00065 1.66634C9.94732 1.66634 12.334 4.05301 12.334 6.99967C12.334 9.94634 9.94732 12.333 7.00065 12.333ZM7.33398 3.66634H6.33398V7.66634L9.83398 9.76634L10.334 8.94634L7.33398 7.16634V3.66634Z" />
);

export default withSvg(16, 16)(SvgTime);
